import { ArrowLeftIcon, ArrowRightIcon } from '@heroicons/react/24/outline';
import { RocketLaunchIcon } from '@heroicons/react/24/solid';
import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useStepper } from '../../components/navigation/Stepper';
import { onboardingSlides } from '../../components/onboarding/OnboardingContent';
import { useOnboarding } from '../../components/onboarding/useOnboarding';

const OnboardingPage: React.FC = () => {
    const navigate = useNavigate();
    const { shouldShow, onDismiss } = useOnboarding();
    const { currentStep, goNext, goBack } = useStepper(0);

    if (!shouldShow) {
        return <Navigate to="/home" replace />;
    }

    const isFirstStep = currentStep === 0;
    const isLastStep = currentStep === onboardingSlides.length - 1;

    const handleNext = () => {
        if (isLastStep) {
            onDismiss();
            navigate('/home');
        } else {
            goNext();
        }
    };

    return (
        <div className="flex flex-col w-full h-screen bg-white overflow-hidden">
            {/* Content */}
            <div className="flex-1 flex items-center justify-center">
                {onboardingSlides[currentStep].content}
            </div>

            {/* Footer */}
            <div className="h-20 w-full flex items-center justify-end px-12 border-t border-gray-100">
                <div className="flex items-center gap-3">
                    {!isFirstStep && (
                        <button
                            onClick={goBack}
                            className="flex items-center gap-2 px-4 py-2.5 text-gray-700 font-semibold text-sm rounded-xl border border-gray-300 hover:bg-gray-50 transition-colors"
                        >
                            <ArrowLeftIcon className="w-4 h-4" />
                            Back
                        </button>
                    )}

                    <button
                        onClick={handleNext}
                        className="flex items-center gap-2 px-6 py-2.5 bg-yellow-400 text-gray-900 font-semibold text-sm rounded-xl shadow hover:bg-yellow-500 transition-colors"
                    >
                        {isLastStep ? (
                            <>
                                Get Started
                                <RocketLaunchIcon className="w-4 h-4" />
                            </>
                        ) : (
                            <>
                                Next
                                <ArrowRightIcon className="w-4 h-4" />
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default OnboardingPage;
